<template>
  <div v-if="dataList && dataList.length" class="multi multi-live">
    <div class="title">
      <h2>다른 고객님이 함께 보신 상품</h2>
    </div>
    <div id="home-shopping-list" class="swiper-container component09">
      <div class="swiper-wrapper">
        <div v-for="(page, index) in pageNum" :key="index" class="swiper-slide">
          <div v-for="index in pageDataNum(page)" :key="index" class="component-list">
            <a :href="pageData(page, index).link | url" target="_blank" rel="noopener noreferrer">
              <div class="vod-img">
                <div class="picture-area">
                  <picture>
                    <img :src="getImage(pageData(page, index).image)" class="thumb" alt=""/>
                  </picture>
                </div>
              </div>
              <strong class="multi-line">{{ pageData(page, index).text }}</strong>
              <span class="fc-purple">{{ pageData(page, index).price | setNumberCommas }}원</span>
            </a>
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</template>

<script>
import Swiper from '@/mixins/swiper'
import { url } from '@/common/filters/url.filter'
import { setNumberCommas } from '@/common/utils/common'
import { resizeThumbnail } from '@/common/utils/image'

export default {
  mixins: [
    Swiper
  ],
  filters: {
    url,
    setNumberCommas
  },
  props: {
    dataList: {
      type: Array
    },
    maxPage: {
      type: Number,
      default: 5
    },
    dataPerPage: {
      type: Number,
      default: 5
    }
  },
  computed: {
    pageNum () {
      const computedPage = Math.ceil(this.dataList.length / this.dataPerPage)
      return Math.min(computedPage, this.maxPage)
    }
  },
  data () {
    return {
      img: '',
      swiperOptions: {
        paginationClickable: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        pagination: '.swiper-pagination',
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev'
      }
    }
  },
  methods: {
    pageData (page, index) {
      const arrayIndex = ((page - 1) * this.dataPerPage) + (index - 1)
      return this.dataList[arrayIndex]
    },
    pageDataNum (page) {
      return Math.min(this.dataPerPage, this.dataList.length - ((page - 1) * this.dataPerPage))
    },
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: 20, quality: 80 })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.swiperElement = '#home-shopping-list'
      this.isReady = true
    })
  }
}
</script>
